(function (root, factory) {
  const api = factory();
  if (typeof module === 'object' && module.exports) module.exports = api;
  else root.RdcChewLimits = api;
})(typeof globalThis !== 'undefined' ? globalThis : this, function () {
  'use strict';
  const bundleId = '6adce6cb6901ad5a0f413950';
  const parentVariants = new Set(['67787677434132', '67787677466900', '67787677499668']);
  const variants = {
    '52577905738004': [4, 0], '52577905770772': [8, 0], '52577905803540': [16, 0],
    '52585268314388': [4, 0], '52585268216084': [8, 0], '52585268248852': [16, 0],
    '53984334086420': [4, 0], '53984333988116': [8, 0], '53984334020884': [16, 0],
    '51904835977492': [0, 3], '52326158205204': [0, 6],
    '52287842418964': [0, 0], '52287842812180': [0, 0],
    '52287842910484': [0, 0], '52287842943252': [0, 0],
    '52550161760532': [0, 0], '52550168707348': [0, 0],
    '52550169690388': [0, 0], '51904862978324': [0, 0]
  };
  const messages = {
    invalid: 'We couldn’t verify this chew box. Please rebuild it before continuing.',
    unsupported: 'This pack size isn’t eligible for this chew-box offer. Please choose another pack.',
    maximum: 'Your chew box can contain up to four packs. Remove a pack to choose a different one.',
    minimum: 'Choose at least two eligible packs to complete your chew box.',
    small: 'This offer allows up to 16 small cheek rolls across all flavors in your cart. Choose another chew to finish your box.',
    large: 'This offer allows up to six 10-inch cheek rolls in your cart. Choose another chew to finish your box.',
    mixed: 'When mixing cheek-roll sizes, choose up to eight small rolls and three large rolls. Remove some cheek rolls or choose another chew.',
    loading: 'Checking your cart quantities. Please try again in a moment.',
    unavailable: 'We couldn’t check your cart quantities. Please try again before adding this chew box.'
  };
  const id = value => String(value ?? '').split('/').pop();
  function count(lines) {
    if (!Array.isArray(lines)) return { error: 'invalid' };
    let small = 0, large = 0, packs = 0;
    for (const line of lines) {
      const v = variants[id(line.variantId ?? line.id)];
      if (!v) return { error: 'unsupported' };
      const q = Number(line.quantity);
      if (!Number.isSafeInteger(q) || q <= 0) return { error: 'invalid' };
      small += v[0] * q; large += v[1] * q; packs += q;
      if (![small, large, packs].every(Number.isSafeInteger)) return { error: 'invalid' };
    }
    return { small, large, packs };
  }
  function check(box, cart = [], complete = false) {
    const selected = count(box), existing = count(cart);
    let error = selected.error || existing.error;
    if (!error && selected.packs > 4) error = 'maximum';
    if (!error && complete && selected.packs < 2) error = 'minimum';
    const small = (selected.small || 0) + (existing.small || 0);
    const large = (selected.large || 0) + (existing.large || 0);
    if (!error && small > 16) error = 'small';
    if (!error && large > 6) error = 'large';
    // One three-roll large base pack shares capacity with two four-roll small base packs.
    if (!error && small * 3 + large * 8 > 48) error = 'mixed';
    return { ok: !error, error: error || null, message: error ? messages[error] : '', small, large, packs: selected.packs || 0 };
  }
  function cartItems(cart) {
    if (!cart || !Array.isArray(cart.items)) throw new Error(messages.invalid);
    const result = [];
    for (const item of cart.items) {
      const properties = item.properties || {};
      const matching = properties['__foxsell:dynamic_add_on_bundle_id'] === bundleId ||
        id(item.product_id) === '15436948832532' || parentVariants.has(id(item.variant_id ?? item.id));
      if (!matching) continue;
      const multiplier = Number(item.quantity);
      if (!Number.isSafeInteger(multiplier) || multiplier <= 0) throw new Error(messages.invalid);
      let components;
      try { components = JSON.parse(properties['__foxsell:dynamic_add_on_bundle_items']); }
      catch (_) { throw new Error(messages.invalid); }
      if (!Array.isArray(components)) throw new Error(messages.invalid);
      const complete = check(components, [], true);
      if (!complete.ok) throw new Error(complete.message);
      for (const component of components) result.push({ variantId: id(component.variantId ?? component.id), quantity: Number(component.quantity) * multiplier });
    }
    const totals = count(result);
    if (totals.error) throw new Error(messages[totals.error]);
    return result;
  }
  return { bundleId, messages, count, check, cartItems };
});
